import type { Time } from "lightweight-charts";

/** Convert milliseconds timestamp to lightweight-charts Time (seconds). */
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- UTCTimestamp is a branded type in lightweight-charts; the Symbol.species brand cannot be satisfied without assertion
export const toChartTime = (ms: number): Time => Math.floor(ms / 1000) as Time;

/** Extract numeric seconds from a lightweight-charts Time value for arithmetic. Pure type narrowing — no assertion needed. */
export function fromChartTime(time: Time): number {
  if (typeof time === "number") return time;
  if (typeof time === "string") return new Date(time).getTime() / 1000;
  return new Date(time.year, time.month - 1, time.day).getTime() / 1000;
}
